(function () {
  'use strict';

  if (window.__insauraQsInit) return;
  window.__insauraQsInit = true;

  /**
   * Read variant data from the embedded JSON script element.
   */
  function getVariants(card) {
    var el = card.querySelector('.qs-variants-data');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  /**
   * Open the size modal (defined in cart-drawer.liquid, exposed globally).
   */
  function triggerModal(card) {
    var vendor     = card.dataset.qsVendor || '';
    var name       = card.dataset.qsName   || '';
    var imgSrc     = card.dataset.qsImg    || '';
    var productUrl = card.dataset.qsUrl    || '';
    var variants   = getVariants(card);

    if (!variants.length) return;

    if (typeof window.InsauraOpenSizeModal === 'function') {
      window.InsauraOpenSizeModal(vendor, name, variants, imgSrc, productUrl);
    }
  }

  /**
   * Bind click handler on a single card.
   */
  function bindCard(card) {
    if (card.dataset.qsBound) return;
    card.dataset.qsBound = '1';

    var trigger = card.querySelector('.qs-trigger');
    if (!trigger) return;

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      triggerModal(card);
    });
  }

  /**
   * Initialise all [data-qs-card] elements.
   */
  function initCards() {
    document.querySelectorAll('[data-qs-card]').forEach(bindCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCards);
  } else {
    initCards();
  }

  document.addEventListener('shopify:section:load', initCards);

  /* Allow filter drawer to re-bind after filtering */
  window.insauraQsRebind = initCards;
})();
